import React from "react";
import DiscoverBtn from "../buttons/DiscoverBtn";
import ReadmoreBtn from "../buttons/ReadmoreBtn";

const CyberBlog = ({ theme }) => {
  return (
    <div className="max-w-6xl mx-auto h-auto py-20 px-6 font-bodyFont">
      <div className="flex flex-col gap-6">
        <h2
          className={`${
            theme === "dark"
              ? "text-darkTextColor decoration-darkLineColor"
              : "text-lightTextColor decoration-lightLineColor"
          } text-2xl mdl:text-[32px] text-center mdl:text-left underline underline-offset-8 font-bold`}
        >
          Discover the Topic related Cyber Security
        </h2>
        <p
          className={`${
            theme === "dark"
              ? "text-darkTextColor decoration-darkLineColor"
              : "text-lightTextColor decoration-lightLineColor"
          } text-sm font-bold mdl:font-normal text-center mdl:text-left mdl:text-[24px]`}
        >
          Cyber Security is what we need for 100%
        </p>
        <p
          className={`${
            theme === "dark"
              ? "text-darkTextColor decoration-darkLineColor"
              : "text-lightTextColor decoration-lightLineColor"
          } text-base text-center mdl:text-left mdl:text-[18px] w-full mdl:w-[500px]`}
        >
          Our team of writers uses a methodology to identify the current major
          threat on Cyber Safety and writing contents which can help you to
          understand the new era of technology in much better way. We are trying
          to make an awareness regarding the Online safety in a bigger view.
        </p>
      </div>
      <div className="py-10 flex flex-col mdl:flex-row justify-center mx-auto mdl:justify-start gap-6 w-72 mdl:w-full">
        <a href="https://blog.reactbd.com/" target="_blank" rel="noreferrer">
          <ReadmoreBtn theme={theme} />
        </a>
        <a href="https://reactbd.com/" target="_blank" rel="noreferrer">
          <DiscoverBtn theme={theme} />
        </a>
      </div>
    </div>
  );
};

export default CyberBlog;
